import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { Markdown } from "../components";
import { SmallText, Heading2, Heading4, Paragraph } from "../styleguide";
import { NAVIGATION_HEIGHT } from "../layouts/Navigation";
import buildAssetUrl from "../utils/buildAssetUrl";
import HeadingNumber from "./HeadingNumber";

const styles = (theme) => ({
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        paddingBottom: 20,
    },
    kickerStyle: {
        color: "#838a92",
        marginBottom: 5,
    },
    headlineStyle: {
        lineHeight: 1.33,
        marginTop: 22,
        marginBottom: 7,
    },
    headingRelative: {
        position: "relative",
    },
    descriptionStyle: {
        marginBottom: 1,
    },
    imageStyle: {
        maxWidth: "100%",
        height: "auto",
    },
    actionLinksStyle: {
        display: "flex",
        flexDirection: "column",
        marginTop: 24,
    },
});

const EMobilityTopicIntro = ({
    kicker,
    title,
    headline,
    description,
    number,
    image,
    children,
    sideNode,
    classes: { containerStyle, kickerStyle, headlineStyle, numberStyle, imageStyle, actionLinksStyle },
}) => {
    let imageUrl;
    if (image) {
        const { url } = buildAssetUrl(image, 400);
        imageUrl = url;
    }

    return (
        <div
            style={{
                padding: `${NAVIGATION_HEIGHT + 31}px 36px 16px 36px`,
                backgroundColor: "#fff",
            }}
            className="intro-section-wrapper"
        >
            <Grid container spacing={0} className={`${containerStyle} intro-section-container`}>
                <Grid item xs={8}>
                    <SmallText className={`${kickerStyle} intro-section-kicker`}>{kicker}</SmallText>
                    <Heading2>
                        {number && <HeadingNumber>{number}</HeadingNumber>}
                        {title}
                    </Heading2>
                    <Heading4 className={headlineStyle}>{headline}</Heading4>
                    <Grid item xs md={10} className="markdown-description-container">
                        <Markdown
                            source={description}
                            renderers={{
                                paragraph: (props) => (
                                    <Paragraph style={{ fontSize: 20, lineHeight: 1.56 }}>{props.children}</Paragraph>
                                ),
                            }}
                        />
                    </Grid>
                    <div className={actionLinksStyle}>{children}</div>
                </Grid>
                <Grid item xs={4}>
                    {sideNode}
                    {imageUrl && <img className={imageStyle} alt={title} src={imageUrl} />}
                </Grid>
            </Grid>
        </div>
    );
};

EMobilityTopicIntro.propTypes = {
    kicker: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EMobilityTopicIntro);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityTopicIntro.js